var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"end"}},[_c('v-btn',{staticClass:"mr-5 mb-5",attrs:{"right":"","color":"primary","loading":_vm.loadSync},on:{"click":_vm.guardarClienteTrilay}},[_vm._v(" Sincronizar Cliente ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }